import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const SalesPerformanceRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.salesResultsApplicationStatusList,
    children: [
      { index: true, lazy: () => import('./sales-performance-list') },
      {
        path: ':id',
        lazy: () => import('./sales-performance-detail'),
      },
      {
        path: ':id/amount-adjustment-details',
        lazy: () => import('./amount-adjustment-detail'),
      },
      {
        path: ':id/amount-adjustment',
        lazy: () => import('./amount-adjustment-update'),
      },
    ],
  },
  {
    path: ROUTES_PATH.salesPerformanceHistoryList,
    children: [
      { index: true, lazy: () => import('./sales-performance-history-list') },
    ],
  },
  {
    path: ROUTES_PATH.salesResultsApplication,
    children: [
      { index: true, lazy: () => import('./sales-performance-detail') },
      {
        path: ':id',
        lazy: () => import('./sales-performance-update'),
      },
      {
        path: ':id/amount-adjustment-details',
        lazy: () => import('./amount-adjustment-detail'),
      },
    ],
  },
];
